export default ['ru', 'en', 'de', 'tr'];
